import { render } from "./MagentoModulesCustomization.vue?vue&type=template&id=09d656be"
import script from "./MagentoModulesCustomization.vue?vue&type=script&lang=js"
export * from "./MagentoModulesCustomization.vue?vue&type=script&lang=js"

import "./MagentoModulesCustomization.vue?vue&type=style&index=0&id=09d656be&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__